import Vip29ApiService from '../services/Vip29ApiService';

export const trackUtm = async (router) => {
    // example url => http://localhost:3005/?utm_source=google&utm_medium=cpc&utm_campaign=brand&utm_action=brand
    const url = `${process.env.HOST}${router.asPath}`;
    await Vip29ApiService.trackUtm({
        url,
    });
};
